module.exports = __webpack_public_path__ + "static/img/product5.6a26221.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product5.jpg
// module id = 6A2d
// module chunks = 0